@if (chartData) {
  <div id="tab-tabell" class="my-4 px-md-4 px-2">
    <div class="row">
      <div class="col-lg-2">
        @if (showSummary()) {
          <button
            (click)="goToSummary()"
            class="my-2 btn btn-outline-primary rounded-circle"
            style="height:40px"
            placement="right" ngbTooltip="{{ 'xml-report.table.summary.header' | translate }}">
            <span class="fas fa-lg fa-chevron-down"></span>
          </button>
        }
      </div>
      <div class="col-lg-8">
        <h4 class="table-title" [innerHTML]="chartData.chartTitle"></h4>
        <h6 class="table-subtitle mb-4" [innerHTML]="chartData.chartSubTitle"></h6>
      </div>
    </div>
    <div class="table-div">
      <angular2-smart-table
        [settings]="settings | async"
        [source]="source">
      </angular2-smart-table>
      <section id="summary">
        @if (showSummary()) {
          <angular2-smart-table
            [settings]="summarySettings | async"
            [source]="summarySource">
          </angular2-smart-table>
        }
      </section>
    </div>
  </div>
}